import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "8",
            height: "4",
            x: "8",
            y: "2",
            rx: "1",
            ry: "1",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M12 11h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 16h4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 11h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 16h.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ClipboardList";
const ClipboardList = memo(themed(Icon));
export {
  ClipboardList
};
//# sourceMappingURL=clipboard-list.js.map
